<template lang="pug">
  div
    b-alert(:show="Boolean(Billings.length)", variant="success") Tu cuenta tiene un plan activo.
    b-row(v-for="(bill, index) in Billings", :key="index")
      b-col
        b-card.no-shadow.mb-0
          div(v-if="bill.plan")
            .d-flex.align-items-start
              h1 {{ bill.plan.name }}
              b-badge.text-sm.ml-2(variant="soft-success", pill) Plan Activo
            p.text-secondary {{ bill.plan.description }}
          div(v-else)
            .d-flex.align-items-start
              h1 Plan {{ bill.plan_id }}
              b-badge.text-sm.ml-2(variant="soft-success", pill) Plan Activo
            p.text-help.text-sm Información de plan no disponible
          hr
          p.mb-0 {{ bill.expire_date_string }}
          p.mb-0.text-secondary.text-sm el {{ $moment(bill.end_date).format('DD [de] MMMM, YYYY') }}
    empty-message(message="No hay suscripciones en esta cuenta", v-if="!billings")
</template>

<script>
export default {
  props: {
    billings: {
      type: Array,
      default: function () {
        return []
      }
    },
    subscriptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    billing: null,
    plan: null,
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    Billings () {
      if (Array.isArray(this.billings) && this.billings.length) {
        return this.billings
      } else if (typeof this.billing == 'object' && typeof this.plan == 'object') {
        let billing = JSON.parse(JSON.stringify(this.billing))
        let plan = JSON.parse(JSON.stringify(this.plan))
        billing.plan = plan

        return [billing]
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
